import { NoRecord } from 'src/styles/emotion';
import { useAPI } from 'src/hooks';
import { useInfiniteQuery } from 'react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import LoadMoreBtn from '@com/buttons/LoadMoreBtn';
import LoadingContainer from '@com/utils/LoadingContainer';
import UserActivityCard from '../card/UserActivityCard';

interface Props {
  isRender: boolean;
  isStop: boolean;
}

function ActivityList(props: Props): JSX.Element {
  /* Define state / hook */
  const { isStop, isRender } = props;
  const { chainId } = web3.useContainer();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const { getUserActivity } = useAPI();
  const { data, isSuccess, isError, hasNextPage, fetchNextPage } =
    useInfiniteQuery<
      Awaited<ReturnType<typeof getUserActivity>>,
      Error,
      Awaited<ReturnType<typeof getUserActivity>>,
      [string, { chainId?: number; uuid?: string }]
    >([getUserActivity.name, { chainId, uuid }], getUserActivity, {
      getNextPageParam: (lastPage) => {
        return lastPage?.next_cursor;
      },
      enabled: isRender,
    });
  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */
  const isEmptyList = useMemo(
    () => data?.pages?.length === 1 && data?.pages[0]?.data?.length === 0,
    [data]
  );

  /* Styling */

  /* Render */
  return (
    <LoadingContainer
      className="w-100"
      iconClassName="w-100 d-flex justify-content-center align-items-center"
      isError={isStop || isError}
      isSuccess={isSuccess}
    >
      {isEmptyList ? (
        <NoRecord>{t('profile.noRecord')}</NoRecord>
      ) : (
        <>
          {data?.pages?.map((page) =>
            page?.data?.map((item) => (
              <UserActivityCard key={item.transaction_hash} data={item} />
            ))
          )}
          <LoadMoreBtn
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
          />
        </>
      )}
    </LoadingContainer>
  );
}

export default ActivityList;
